import React, { useState } from 'react'
import './style.css'
import Header from '../layout/header'
import { useQuery } from '@apollo/client'
import { GET_MONTH_REPORT } from '../graphql/query'
import Chart from 'react-apexcharts'

export default function QuarterlyReport() {
  const [select, setSelect] = useState(0)

  const { data, loading } = useQuery(GET_MONTH_REPORT, {
    variables: {
      "months": monthNames
    }
  })

  return (
    <div className='Dashboard'>
      <Header title={"Quarterly Report"} month={select} setMonth={setSelect} />
      <span className='Dashboard_Con' style={{ paddingBottom: 15 }}>
        {loading ?
          <div className="Loading">
            Loading...
          </div>
          :
          <>
            {/* <h2>2000 churches</h2> */}
            <div>
              <h3>2000 churches</h3>
              <div className='Dashboard_Grid_Con'>
                <Report select={select} data={data} role={"Relational"} id={"noWhyPhone"} title={"No. of Why Pack Phone Calls"} />
              </div>
            </div>
            {/* <h2>406 RE Teachers</h2> */}
            <div>
              <h3>406 RE Teachers</h3>
              <div className='Dashboard_Grid_Con'>
                <Report select={select} data={data} role={"Innovation"} id={"noRequestReg"} title={"No. of RE:Quest registered teachers"} />
              </div>
            </div>
            <div>
              <h3>200 Partner Churches</h3>
              <div className='Dashboard_Grid_Con'>
                <Report select={select} data={data} role={"Together"} id={"noNewSubscriber"} title={"No. of New Resource Subscribers"} />
              </div>
            </div>
            <div>
              <h3>4 Centres</h3>
              <div className='Dashboard_Grid_Con'>
                <Report select={select} data={data} role={"Relational"} id={"noCentreNew"} title={"No. of New Centres"} />
              </div>
            </div>
          </>
        }
      </span>
    </div>
  )
}

function Report({ title, data, role, id, select }) {
  const yearTarget = data?.getTargets?.find((e) => e?.role === role)
  const target = data?.getMonthTargets?.find((e) => e?.role === role && e?.month === quarterMonths[select][3])
  const year = yearTarget?.targets ? JSON?.parse(yearTarget?.targets) : {}
  const month = target?.targets ? JSON.parse(target?.targets) : {}
  const selectedMonth = monthNames?.findIndex((e) => e === quarterMonths[select][3])

  const thisMonth = monthNames?.filter((itm, ind)=> ind <= selectedMonth)
  const lastMonth = monthNames?.filter((itm, ind)=> ind <= selectedMonth - 1)
  const preMonth = monthNames?.filter((itm, ind)=> ind <= selectedMonth - 2)
  const prePreMonth = monthNames?.filter((itm, ind)=> ind <= selectedMonth - 3)

  const datass = data?.getMonthReports?.filter((e) => e?.role === role)

  var options = {
    chart: {
      type: 'bar',
      xaxis: {
        categories: quarterMonths[select]?.map((item) => {
          return item?.slice(0, 3) + '-' + item?.slice(-2)
        })
      },
      chart: {
        toolbar: {
          show: false
        }
      },
      stroke: {
        width: 2
      },
      tooltip: {
        custom: function ({ series, seriesIndex, dataPointIndex, w }) {
          return (
            `<div class="ToolTip">
                  ${w.globals.labels[dataPointIndex]}: ${series[seriesIndex][dataPointIndex]}
                  </div>`
          )
        }
      },
    },
    series: [{
      name: 'sales',
      data: quarterMonths[select]?.map((itms, inds) => {
        if (inds === 3) {
          let val = 0
          thisMonth?.forEach((itm) => {
            const datas = datass?.find((e) => e?.month === itm)?.reports ? JSON.parse(datass?.find((e) => e?.month === itm)?.reports) : {}
            const monthVal = parseFloat(datas[id]) || 0
            val += monthVal
          })
          return val
        } else if (inds === 2) {
          let val = 0
          lastMonth?.forEach((itm) => {
            const datas = datass?.find((e) => e?.month === itm)?.reports ? JSON.parse(datass?.find((e) => e?.month === itm)?.reports) : {}
            const monthVal = parseFloat(datas[id]) || 0
            val += monthVal
          })
          return val
        } else if (inds === 1) {
          let val = 0
          preMonth?.forEach((itm) => {
            const datas = datass?.find((e) => e?.month === itm)?.reports ? JSON.parse(datass?.find((e) => e?.month === itm)?.reports) : {}
            const monthVal = parseFloat(datas[id]) || 0
            val += monthVal
          })
          return val
        } else {
          let val = 0
          prePreMonth?.forEach((itm) => {
            const datas = datass?.find((e) => e?.month === itm)?.reports ? JSON.parse(datass?.find((e) => e?.month === itm)?.reports) : {}
            const monthVal = parseFloat(datas[id]) || 0
            val += monthVal
          })
          return val
        }
      })
    }],
  }

  const getAchieved = () => {
    let val = 0
    thisMonth?.forEach((itm) => {
      const datas = datass?.find((e) => e?.month === itm)?.reports ? JSON.parse(datass?.find((e) => e?.month === itm)?.reports) : {}
      const monthVal = parseFloat(datas[id]) || 0
      val += monthVal
    })
    return val
  }

  return (
    <div className='Dashboard_Grid_Item'>
      <div className='Dashboard_Grid_Left'>
        <h4>{title}</h4>
        <div className='FlexCon' />
        <p>Yearly Target: {year[id] || "--"}</p>
        <p>Monthly Accumulated Target: {month[id] || "--"}</p>
        <div className='FlexCon' />
        <div className={getAchieved() > month[id]? 'Dashboard_Grid_Ind Dashboard_Grid_Ind_Green' : getAchieved() < month[id]? 'Dashboard_Grid_Ind Dashboard_Grid_Ind_Red' : 'Dashboard_Grid_Ind'}/>
      </div>
      <div className='Dashboard_Grid_Right'>
        <Chart height={"230"} options={options?.chart} series={options?.series} type='bar' />
      </div>
    </div>
  )
}

const monthNames = ['September-2024', 'October-2024', 'November-2024', 'December-2024', 'January-2025', 'February-2025', 'March-2025', 'April-2025', 'May-2025', 'June-2025', 'July-2025', 'August-2025', 'September-2025', 'October-2025', 'November-2025', 'December-2025', 'January-2026', 'February-2026', 'March-2026', 'April-2026', 'May-2026', 'June-2026', 'July-2026', 'August-2026'];

const quarterMonths = [
  ['September-2024', 'October-2024', 'November-2024', 'December-2024'],
  ['January-2025', 'February-2025', 'March-2025', 'April-2025'],
  ['May-2025', 'June-2025', 'July-2025', 'August-2025'],
  ['September-2025', 'October-2025', 'November-2025', 'December-2025'],
  ['January-2026', 'February-2026', 'March-2026', 'April-2026'],
  ['May-2026', 'June-2026', 'July-2026', 'August-2026']
]